import { router, useLocalSearchParams } from "expo-router";
import React, { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";

import { surface } from "@/src/theme/tokens";

/**
 * Retired legacy UID-scoped group member-management route.
 * Group membership is now managed from the identity-aware group surface.
 */
export default function RetiredLegacyAddMembersRoute() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const groupId = String(id || "");

  useEffect(() => {
    if (!groupId) {
      router.replace("/(tabs)/messages");
      return;
    }
    router.replace({
      pathname: "/group/[groupId]",
      params: { groupId },
    });
  }, [groupId]);

  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: surface.secondary }}>
      <ActivityIndicator />
    </View>
  );
}
